<template>
  <span>
    <svg
      style="width: 20px;height: 20px;margin-left: 5px;position: relative;top: -10px;cursor: pointer;user-select: none;"
      fill="#ffffff"
      t="1772350472710"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="2533"
      @click.stop="handleClick"
    >
      <path d="M68.736 764.544a41.28 41.28 0 0 0 71.488-41.28 426.816 426.816 0 1 1 166.4 161.92 41.28 41.28 0 1 0-39.232 72.704 509.44 509.44 0 1 0-198.72-193.28z" fill="#fffFFF" p-id="2534" data-spm-anchor-id="a313x.search_index.0.i1.35dc3a81rWdmlP" class="" />
      <path
        d="M371.328 353.152L304.96 419.52a41.28 41.28 0 0 1-58.368-58.368l134.272-134.272a41.216 41.216 0 0 1 73.088 26.304v513.024a41.28 41.28 0 0 1-82.56 0V353.152z m276.736 313.088l66.368-66.368a41.28 41.28 0 0 1 58.368 58.368l-134.208 134.4a41.216 41.216 0 0 1-73.152-26.432V253.184a41.28 41.28 0 0 1 82.624 0v413.056z"
        fill="#fffFFF"
        p-id="2535"
        data-spm-anchor-id="a313x.search_index.0.i0.35dc3a81rWdmlP"
        class="selected"
      />
    </svg>
    <span class="task" @click.stop="handleClick">{{ $tr('menu.name.taskList', 'Task Center') }}</span>

    <!-- 自定义遮罩层 -->
    <div v-show="drawer" class="custom-mask" @click="closeDrawer" />
    <!-- 自定义抽屉 -->
    <div v-show="drawer" class="task-drawer">
      <div class="drawer-content">
        <el-tabs v-model="activeName">
          <el-tab-pane v-for="(item, index) in tabMapOptions" :key="index" :label="getTabLabel(item)" :name="item.key">
            <span slot="label">
              <span>{{ getTabLabel(item) }}</span>
            </span>
            <tab-pane
              v-if="activeName === item.key"
              :key="activeKey"
              ref="tabPane"
              :task-type="item.key"
              @click="changeActive(index)"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </span>
</template>

<script>
import TabPane from '@/components/TaskTabPane/index'

export default {
  name: 'TaskList',
  components: { TabPane },
  data() {
    return {
      activeName: 'DOWNLOAD',
      drawer: false,
      activeKey: 'DOWNLOAD',
      clickTimeout: null,
      tabMapOptions: [
        { labelKey: 'task.export.task', defaultLabel: 'Export Task', key: 'DOWNLOAD' },
        { labelKey: 'task.import.task', defaultLabel: 'Import Task', key: 'UPLOAD' }
      ]
    }
  },
  watch: {
    activeName(newVal) {
      // 监听 tab 切换，刷新对应数据
      this.$nextTick(() => {
        const tabPanes = this.$refs.tabPane
        if (tabPanes && Array.isArray(tabPanes) && tabPanes.length > 0) {
          const currentPane = tabPanes[0]
          if (currentPane && currentPane.refreshData) {
            currentPane.refreshData()
          }
        } else if (tabPanes && tabPanes.refreshData) {
          tabPanes.refreshData()
        }
      })
    }
  },
  beforeDestroy() {
    // 清理定时器
    if (this.clickTimeout) {
      clearTimeout(this.clickTimeout)
    }
  },
  methods: {
    getTabLabel(item) {
      return this.$tr(item.labelKey, item.defaultLabel)
    },
    changeActive(key) {
      this.activeKey = key
      // activeName 会在 el-tabs 的 v-model 作用下自动更新，由 watch 监听处理
    },
    closeDrawer() {
      this.drawer = false
    },
    handleClick(event) {
      // 防止快速连续点击
      if (this.clickTimeout) {
        clearTimeout(this.clickTimeout)
      }

      // 阻止事件冒泡，防止影响父组件布局
      if (event) {
        event.stopPropagation()
      }

      // 设置防抖延迟
      this.clickTimeout = setTimeout(() => {
        this.drawer = true
        this.clickTimeout = null
        // 打开弹框时刷新数据
        this.refreshData()
      }, 100)
    },
    refreshData() {
      // 通知所有 TabPane 组件刷新数据
      this.$nextTick(() => {
        const tabPanes = this.$refs.tabPane
        if (tabPanes && Array.isArray(tabPanes)) {
          tabPanes.forEach(pane => {
            if (pane && pane.refreshData) {
              pane.refreshData()
            }
          })
        } else if (tabPanes && tabPanes.refreshData) {
          tabPanes.refreshData()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.task {
  color: white;
  position: relative;
  top: -15px;
  margin-left: 5px;
  margin-right: 10px;
  font-size: 14px;
  cursor: pointer;
}
/* 自定义遮罩层样式 */
.custom-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 3999;
  animation: fadeIn 0.3s ease;
}

/* 自定义抽屉样式 */
.task-drawer {
  position: fixed;
  top: 0;
  right: 0;
  width: 420px;
  height: 100%;
  background-color: #f3f4f8;
  z-index: 4000;
  box-shadow: -2px 0 12px rgba(0, 0, 0, 0.1);
  animation: slideIn 0.3s ease;
}

.drawer-content {
  padding: 16px;
  height: 100%;
  overflow-y: auto;
}

/* 动画效果 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes slideIn {
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
}

/* 移除 Element UI 相关样式 */
::v-deep .el-drawer {
  display: none !important;
}

::v-deep .v-modal {
  display: none !important;
}

/* 防止页面滚动条跳动 */
::v-deep .el-popup-parent--hidden {
  padding-right: 0 !important;
  overflow: hidden !important;
}

</style>
